(() => {
 if (window.lvMotionReady) return;
 window.lvMotionReady = true;
 const root = document.querySelector('[data-lv-motion-root]');
 if (!root || root.dataset.motionEnabled === 'false') return;
 const intensity = Math.max(0,Math.min(150,Number(root.dataset.motionIntensity) || 0))/100;
 if (!intensity) return;
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const mobile = matchMedia('(max-width: 749px)');
 const entries = new Map(), visible = new Set();
 let raf = 0, active = false;
 const observer = new IntersectionObserver(records => {
  for (const r of records) { const item=entries.get(r.target); if (!item) continue; r.isIntersecting ? visible.add(item) : visible.delete(item); }
  schedule();
 });
 const specs = [
  ['.lv-hero-art',70,'hero'],['.lv-hero-copy',-18,'copy'],
  ['lv-parallax .lv-story-image img',52,'story'],['.lv-card-visual',8,'card'],
  ['.collection-hero__title, .product__title, .main-page-title, .title--primary, .customer h1, .lv-policy h1, .preview-title, .article-template__title, .shopify-policy__title',14,'heading'],
  ['.product__media-wrapper>media-gallery, .preview-product-art',12,'product'],
  ['[data-lv-depth]',42,'decoration']
 ];
 function scan() {
  for (const [selector,amplitude,kind] of specs) for (const el of root.querySelectorAll(selector)) {
   if(entries.has(el)) continue;
   if(kind==='story' && el.closest('lv-parallax')?.dataset.strength==='0') continue;
   el.dataset.lvMotion=kind;
   const item={el,amplitude,y:0}; entries.set(el,item);
   if(active) observer.observe(el);
  }
  for(const [el,item] of entries) if(!el.isConnected){observer.unobserve(el);visible.delete(item);entries.delete(el);}
  schedule();
 }
 function tick() {
  raf=0;if(!active)return;
  const factor=intensity*(mobile.matches ? .2 : 1),height=innerHeight;
  // Read all visible rectangles before any writes. Remove the previous offset from geometry.
  const updates=[];
  for(const item of visible){const rect=item.el.getBoundingClientRect();const center=rect.top+rect.height/2-item.y;const position=Math.max(-1,Math.min(1,(height/2-center)/(height*.7)));updates.push([item,position*item.amplitude*factor]);}
  for(const [item,y] of updates){item.y=y;item.el.style.setProperty('--lv-motion-y',`${y.toFixed(2)}px`);}
 }
 function schedule(){if(active && !raf)raf=requestAnimationFrame(tick);}
 function configure(){
  active=!reduced.matches && !navigator.connection?.saveData;
  observer.disconnect();visible.clear();cancelAnimationFrame(raf);raf=0;
  window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);
  for(const [el,item] of entries){item.y=0;el.style.removeProperty('--lv-motion-y');if(active)observer.observe(el);}
  if(active){window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});}
 }
 reduced.addEventListener('change',configure);mobile.addEventListener('change',schedule);
 document.addEventListener('shopify:section:load',scan);
 // Facets and product recommendations replace markup without a full navigation.
 const mutations=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes,...r.removedNodes].some(n=>n.nodeType===1)))scan();});
 mutations.observe(root,{childList:true,subtree:true});
 scan();configure();
})();
